import { render } from "./NotificationInitial.vue?vue&type=template&id=7910a3d0&scoped=true"
import script from "./NotificationInitial.vue?vue&type=script&lang=ts"
export * from "./NotificationInitial.vue?vue&type=script&lang=ts"

import "./NotificationInitial.vue?vue&type=style&index=0&id=7910a3d0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7910a3d0"

export default script